import styled from "styled-components";

import * as css from "styles/CssVariables.js";

import userCircleIcon from "assets/img/icons/user-single-icon.svg";
import userCircleWhiteIcon from "assets/img/icons/user-single-icon-white.svg";
import percentWhiteIcon from "assets/img/icons/percent-icon-white.svg";

const StatsBox = styled.div`
  padding: 15px 20px;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  display: grid;
  grid-template-columns: 37px 73px 73px 1fr;
  grid-template-rows: 25px 1fr 1fr 1fr;
`;

const BoxLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
`;

const LabelIconCell = styled.div`
  display: flex;
  align-items: center;
`;

const LabelIcon = styled.div`
  width: 16px;
  min-width: 16px;
  height: 16px;
`;

const ValueCell = styled.div`
  height: 24px;

  font-size: 13px;

  display: flex;
  align-items: center;
`;

const ChangeBadge = styled.div`
  height: 16px;
  padding: 0 4px 1px;
  margin-left: 5px;

  font-size: 11px;

  border-radius: 8px;
  background: ${(props) =>
    props.green ? css.POSITIVE_GREEN : css.NEGATIVE_RED};

  display: flex;
  justify-content: center;
  align-items: center;
`;

export default ({ data }) => {
  const {
    last24HoursLeads,
    last24HoursVerifiedLeads,
    prev24HoursLeads,
    prev24HoursVerifiedLeads,
    last7DaysLeads,
    last7DaysVerifiedLeads,
    prev7DaysLeads,
    prev7DaysVerifiedLeads,
    allLeads,
    allVerifiedLeads,
    trendsData,
  } = data.listBuildingData.leadsStats;

  const changeBadge = (change) => {
    if (typeof change !== "number" || change === 0) return <></>;

    if (change > 100) return <ChangeBadge green={true}>&gt;100%</ChangeBadge>;

    const roundCoef = change >= 10 || change <= -10 ? 1 : 10;
    let changeRounded = Math.round(change * roundCoef) / roundCoef;

    if (changeRounded >= 0)
      return <ChangeBadge green={true}>+{changeRounded}%</ChangeBadge>;
    else return <ChangeBadge green={false}>{changeRounded}%</ChangeBadge>;
  };

  const last24HoursLeadsChange =
    prev24HoursLeads > 0
      ? (100 / prev24HoursLeads) * last24HoursLeads - 100
      : "-";

  const last7DaysLeadsChange =
    prev7DaysLeads > 0 ? (100 / prev7DaysLeads) * last7DaysLeads - 100 : "-";

  const last24HoursVerifiedLeadsChange =
    prev24HoursVerifiedLeads > 0
      ? (100 / prev24HoursVerifiedLeads) * prev24HoursVerifiedLeads - 100
      : "-";

  const last7DaysVerifiedLeadsChange =
    prev7DaysVerifiedLeads > 0
      ? (100 / prev7DaysVerifiedLeads) * last7DaysVerifiedLeads - 100
      : "-";

  const last24hoursVerifiedPercent =
    last24HoursLeads > 0
      ? Math.round((100 / last24HoursLeads) * last24HoursVerifiedLeads * 10) /
        10
      : 0;

  const last7DaysVerifiedPercent =
    last7DaysLeads > 0
      ? Math.round((100 / last7DaysLeads) * last7DaysVerifiedLeads * 10) / 10
      : 0;

  const allVerifiedPercent =
    allLeads > 0
      ? Math.round((100 / allLeads) * allVerifiedLeads * 10) / 10
      : 0;

  return (
    <StatsBox>
      <BoxLabel></BoxLabel>
      <BoxLabel>24 Hours</BoxLabel>
      <BoxLabel>7 Days</BoxLabel>
      <BoxLabel>Total</BoxLabel>
      <LabelIconCell>
        <LabelIcon>
          <img src={userCircleIcon} style={{ width: "100%" }} />
        </LabelIcon>
      </LabelIconCell>
      <ValueCell>
        {last24HoursLeads}
        {changeBadge(last24HoursLeadsChange)}
      </ValueCell>
      <ValueCell>
        {last7DaysLeads}
        {changeBadge(last7DaysLeadsChange)}
      </ValueCell>
      <ValueCell>{allLeads}</ValueCell>
      <LabelIconCell>
        <LabelIcon>
          <img src={userCircleWhiteIcon} style={{ width: "100%" }} />
        </LabelIcon>
      </LabelIconCell>
      <ValueCell>
        {last24HoursVerifiedLeads}
        {changeBadge(last24HoursVerifiedLeadsChange)}
      </ValueCell>
      <ValueCell>
        {last7DaysVerifiedLeads}
        {changeBadge(last7DaysVerifiedLeadsChange)}
      </ValueCell>
      <ValueCell>{allVerifiedLeads}</ValueCell>
      <LabelIconCell>
        <LabelIcon>
          <img src={percentWhiteIcon} style={{ width: "100%" }} />
        </LabelIcon>
      </LabelIconCell>
      <ValueCell>{last24hoursVerifiedPercent}%</ValueCell>
      <ValueCell>{last7DaysVerifiedPercent}%</ValueCell>
      <ValueCell>{allVerifiedPercent}%</ValueCell>
    </StatsBox>
  );
};
